// src/components/AccountDeletion.js
// Page publique expliquant comment supprimer son compte et ses données.
// URL exigée par Google Play (Data safety → suppression des données).
import React from "react";
import { useTranslation } from "react-i18next";

export default function AccountDeletion() {
    const { t } = useTranslation();
    const list = (key) => {
        const v = t(key, { returnObjects: true });
        return Array.isArray(v) ? v : [];
    };

    return (
        <div
            style={{
                maxWidth: 900,
                margin: "40px auto",
                padding: "20px",
                background: "#fff",
                borderRadius: 12,
                boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
                fontFamily: "Arial, sans-serif",
                lineHeight: 1.6,
                color: "#222",
            }}
        >
            <h2 style={{ color: "var(--primary-blue)", textAlign: "center", marginBottom: 10 }}>
                {t("accountDeletion.title")}
            </h2>
            <p style={{ textAlign: "center", color: "#666", marginTop: 0 }}>
                Swiss Dive Agenda
            </p>

            <hr style={{ margin: "18px 0", borderColor: "#eee" }} />

            <h3>{t("accountDeletion.inApp.title")}</h3>
            <p>{t("accountDeletion.inApp.intro")}</p>
            <ol style={{ paddingLeft: 20 }}>
                {list("accountDeletion.inApp.steps").map((s, i) => (
                    <li key={i}>{s}</li>
                ))}
            </ol>

            <h3>{t("accountDeletion.partial.title")}</h3>
            <p>{t("accountDeletion.partial.intro")}</p>
            <ul style={{ paddingLeft: 20 }}>
                {list("accountDeletion.partial.items").map((s, i) => (
                    <li key={i}>{s}</li>
                ))}
            </ul>
            <p>{t("accountDeletion.partial.note")}</p>

            <h3>{t("accountDeletion.deleted.title")}</h3>
            <p>{t("accountDeletion.deleted.intro")}</p>
            <ul style={{ paddingLeft: 20 }}>
                {list("accountDeletion.deleted.items").map((s, i) => (
                    <li key={i}>{s}</li>
                ))}
            </ul>
            <p>{t("accountDeletion.deleted.retention")}</p>

            <h3>{t("accountDeletion.byEmail.title")}</h3>
            <p>
                {t("accountDeletion.byEmail.content")}{" "}
                <strong>contact@swissdiveagenda.ch</strong>
            </p>

            <hr style={{ margin: "18px 0", borderColor: "#eee" }} />

            <button
                type="button"
                onClick={() => {
                    window.close();
                    setTimeout(() => { window.location.href = "/"; }, 150);
                }}
                style={{
                    width: "100%",
                    padding: "10px",
                    background: "var(--primary-blue)",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontWeight: "bold",
                    marginTop: 8,
                }}
            >
                {t("common.close")}
            </button>
        </div>
    );
}
